import { useTheme } from "../../../theme/ThemeProvider";
import { ITheme } from "../../../theme/ITheme";
import { IHeaderStyles } from "../../styles";

export const useHeaderStyles = (theme?: ITheme): IHeaderStyles => {
    if (theme === undefined) {
        theme = useTheme();
    }

    return {
        header: {
            backgroundColor: theme.palette.accent.dark,
            color: theme.palette.text.light,
            height: theme.spacePx.sp08,
        },
        headerContainer: {
            color: "inherit",
            cursor: "pointer",
        },
        headerIcon: {
            fontSize: "1.35rem",
        },
        headerItem: {
            color: "inherit",
            cursor: "pointer",
            fontSize: theme.font.sizes.lg,
            textTransform: "none",
            textDecoration: "none"
        },
        logo: {
            height: "2.5rem",
        },
    }
}